
import { padNum } from '~/services/helpers'
export default
	props:
		hasJobs: Boolean
		jobs: Object
		activeJobs: Object
		jobMatch: Function
		maskLocation: Function
		maskType: Function
		loading: Boolean
		layout: String
		hasFilters: Boolean

	computed:
		toggleIcon: -> if @layout == "default" then "Arrow" else "Chevron"

	methods: {padNum}

